<template>
    <transition appear name="fade-transition">
        <template v-if="error || !src">
            <v-img
                v-if="!hideFallback"
                class="app-image app-image--fallback"
                :src="Auth().branding().image('avatar')"
                :aspect-ratio="aspectRatio"
                :contain="contain"
                :position="position"
                :height="height"
                :width="width"
                :max-height="maxHeight"
                :max-width="maxWidth"
                :min-height="minHeight"
                :min-width="minWidth"
            >
                <template #placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="primaryBackground" />
                    </v-row>
                </template>
            </v-img>
        </template>
        <template v-else>
            <v-img
                class="app-image"
                :alt="alt"
                :src="src"
                :aspect-ratio="aspectRatio"
                :contain="contain"
                :position="position"
                :height="height"
                :width="width"
                :max-height="maxHeight"
                :max-width="maxWidth"
                :min-height="minHeight"
                :min-width="minWidth"
                @loadstart="onLoadStart"
                @load="onLoad"
                @error="onError"
            >
                <template #placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="primaryBackground" />
                    </v-row>
                </template>
            </v-img>
        </template>
    </transition>
</template>

<script>
export default {
    name: 'AppImage',
    props: {
        alt: {
            type: String,
            default: ''
        },
        src: {
            type: String,
            default: null
        },
        contain: {
            type: Boolean,
            default: false
        },
        aspectRatio: {
            type: String,
            default: ''
        },
        position: {
            type: String,
            default: 'center center'
        },
        height: {
            type: String,
            default: null
        },
        width: {
            type: String,
            default: null
        },
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        },
        minHeight: {
            type: String,
            default: null
        },
        minWidth: {
            type: String,
            default: null
        },
        hideFallback: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        loading: false,
        error: false
    }),
    methods: {
        onLoadStart() {
            this.loading = true;
            this.$emit('load:start');
        },
        onLoad() {
            this.loading = false;
            this.$emit('load:end');
        },
        onError() {
            this.error = true;
            this.loading = false;
            this.$emit('error');
        }
    }
};
</script>
